/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetDataFirstStage200ResponseDataCustomerOrganizationData } from './GetDataFirstStage200ResponseDataCustomerOrganizationData'
import {
  GetDataFirstStage200ResponseDataCustomerOrganizationDataFromJSON,
  GetDataFirstStage200ResponseDataCustomerOrganizationDataFromJSONTyped,
  GetDataFirstStage200ResponseDataCustomerOrganizationDataToJSON,
} from './GetDataFirstStage200ResponseDataCustomerOrganizationData'
import type { GetDataFirstStage200ResponseDataOwnerOrganizationData } from './GetDataFirstStage200ResponseDataOwnerOrganizationData'
import {
  GetDataFirstStage200ResponseDataOwnerOrganizationDataFromJSON,
  GetDataFirstStage200ResponseDataOwnerOrganizationDataFromJSONTyped,
  GetDataFirstStage200ResponseDataOwnerOrganizationDataToJSON,
} from './GetDataFirstStage200ResponseDataOwnerOrganizationData'
import type { OrganizationType } from './OrganizationType'
import {
  OrganizationTypeFromJSON,
  OrganizationTypeFromJSONTyped,
  OrganizationTypeToJSON,
} from './OrganizationType'
import type { ImageSignType } from './ImageSignType'
import {
  ImageSignTypeFromJSON,
  ImageSignTypeFromJSONTyped,
  ImageSignTypeToJSON,
} from './ImageSignType'

/**
 *
 * @export
 * @interface GetDataFirstStage200ResponseData
 */
export interface GetDataFirstStage200ResponseData {
  /**
   * Словесное наименование знака; null для заявки с изображением
   * @type {string}
   * @memberof GetDataFirstStage200ResponseData
   */
  brand: string | null
  /**
   * Ссылка на изображение знака; null для словесного знака
   * @type {string}
   * @memberof GetDataFirstStage200ResponseData
   */
  image: string | null
  /**
   * Тип знака: W — словесный, D — изобразительный, C — комбинированный
   * @type {ImageSignType}
   * @memberof GetDataFirstStage200ResponseData
   */
  imageType: ImageSignType | null
  /**
   * Заказчик и правообладатель совпадали при заполнении
   * @type {boolean}
   * @memberof GetDataFirstStage200ResponseData
   */
  isEqual: boolean
  /**
   * Тип организации заказчика
   * @type {OrganizationType}
   * @memberof GetDataFirstStage200ResponseData
   */
  customerOrganizationType: OrganizationType
  /**
   * Тип организации правообладателя
   * @type {OrganizationType}
   * @memberof GetDataFirstStage200ResponseData
   */
  ownerOrganizationType: OrganizationType
  /**
   *
   * @type {GetDataFirstStage200ResponseDataCustomerOrganizationData}
   * @memberof GetDataFirstStage200ResponseData
   */
  customerOrganizationData: GetDataFirstStage200ResponseDataCustomerOrganizationData
  /**
   *
   * @type {GetDataFirstStage200ResponseDataOwnerOrganizationData}
   * @memberof GetDataFirstStage200ResponseData
   */
  ownerOrganizationData: GetDataFirstStage200ResponseDataOwnerOrganizationData
}

/**
 * Check if a given object implements the GetDataFirstStage200ResponseData interface.
 */
export function instanceOfGetDataFirstStage200ResponseData(
  value: object
): value is GetDataFirstStage200ResponseData {
  if (!('brand' in value) || value['brand'] === undefined) return false
  if (!('image' in value) || value['image'] === undefined) return false
  if (!('imageType' in value) || value['imageType'] === undefined) return false
  if (!('isEqual' in value) || value['isEqual'] === undefined) return false
  if (
    !('customerOrganizationType' in value) ||
    value['customerOrganizationType'] === undefined
  )
    return false
  if (
    !('ownerOrganizationType' in value) ||
    value['ownerOrganizationType'] === undefined
  )
    return false
  if (
    !('customerOrganizationData' in value) ||
    value['customerOrganizationData'] === undefined
  )
    return false
  if (
    !('ownerOrganizationData' in value) ||
    value['ownerOrganizationData'] === undefined
  )
    return false
  return true
}

export function GetDataFirstStage200ResponseDataFromJSON(
  json: any
): GetDataFirstStage200ResponseData {
  return GetDataFirstStage200ResponseDataFromJSONTyped(json, false)
}

export function GetDataFirstStage200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetDataFirstStage200ResponseData {
  if (json == null) {
    return json
  }
  return {
    brand: json['brand'],
    image: json['image'],
    imageType: ImageSignTypeFromJSON(json['imageType']),
    isEqual: json['isEqual'],
    customerOrganizationType: OrganizationTypeFromJSON(
      json['customerOrganizationType']
    ),
    ownerOrganizationType: OrganizationTypeFromJSON(
      json['ownerOrganizationType']
    ),
    customerOrganizationData:
      GetDataFirstStage200ResponseDataCustomerOrganizationDataFromJSON(
        json['customerOrganizationData']
      ),
    ownerOrganizationData:
      GetDataFirstStage200ResponseDataOwnerOrganizationDataFromJSON(
        json['ownerOrganizationData']
      ),
  }
}

export function GetDataFirstStage200ResponseDataToJSON(
  value?: GetDataFirstStage200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    brand: value['brand'],
    image: value['image'],
    imageType: ImageSignTypeToJSON(value['imageType']),
    isEqual: value['isEqual'],
    customerOrganizationType: OrganizationTypeToJSON(
      value['customerOrganizationType']
    ),
    ownerOrganizationType: OrganizationTypeToJSON(
      value['ownerOrganizationType']
    ),
    customerOrganizationData:
      GetDataFirstStage200ResponseDataCustomerOrganizationDataToJSON(
        value['customerOrganizationData']
      ),
    ownerOrganizationData:
      GetDataFirstStage200ResponseDataOwnerOrganizationDataToJSON(
        value['ownerOrganizationData']
      ),
  }
}
